import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./login.module.css";
import logo from "../../images/logo.png";
import bg from "../../images/login_therapists_bg.png";
import { useState } from "react";
import LoginSmsForm from "../../components/forms/loginSmsForm/loginSmsForm";
import LoginEmailForm from "../../components/forms/loginEmailForm/loginEmailForm";
import i18n from "../../i18n";

function LoginPage() {
  const [way, setWay] = useState("email");
  const [showSupportPopup, setShowSupportPopup] = useState(false);

  return (
    <section dir={i18n.dir()} className={`${styles.loginTherapistPage}`} data-testid="login-page">
      <img
        src={logo}
        alt={t("LOGIN_PAGE_LOGO_ALT")}
        className={`${styles.loginTherapistPageLogo} ${styles.loginTherapistPageLogo_mobile}`}
      />

      <div className={styles.loginTherapistContent}>
        <img
          src={logo}
          alt={t("LOGIN_PAGE_LOGO_ALT")}
          className={styles.loginTherapistPageLogo}
        />
        <h2 className={styles.loginTherapistTitle}>
          {t("LOGIN_PAGE_ADMIN_TITLE")}
        </h2>
        <img
          src={bg}
          className={styles.loginTherapistImage}
          alt={t("LOGIN_PAGE_BG_ALT")}
        />
      </div>
      <article className={`${styles.login}`}>
        <h1 className={styles.login__title}>{t("LOGIN_PAGE_LOGIN_TITLE")}</h1>
        <p className={styles.login__text}>{t("LOGIN_PAGE_LOGIN_TEXT")}</p>
        <div className={styles.login__way}>
          <button
            type="button"
            onClick={() => setWay("email")}
            className={`${styles.login__radioLabel} ${
              way === "email" && styles.login__radioLabel_active
            }`}
            data-testid="email-tab-button"
          >
            {t("LOGIN_PAGE_WAY_EMAIL")}
          </button>
          <button
            type="button"
            onClick={() => setWay("sms")}
            className={`${styles.login__radioLabel} ${
              way === "sms" && styles.login__radioLabel_active
            }`}
            data-testid="sms-tab-button"
          >
            {t("LOGIN_PAGE_WAY_SMS")}
          </button>
        </div>
        {way === "sms" ? <LoginSmsForm /> : <LoginEmailForm />}
        {/* <button
          type={"button"}
          disabled={true}
          // onClick={() => navigate("signin")}
          className={`button ${styles.login__button} button_white ${styles.login__button_type_signup} disabled`}
        >
          {t("LOGIN_PAGE_SIGNUP_BUTTON")}
        </button> */}
        <div>
          <p className={styles.login__conditions}>
            {t("LOGIN_PAGE_USE_CONDITIONS")}
          </p>
          {/*<Link className={styles.login__link} to={"/terms"}>*/}
          {/*  בתקנון השימוש*/}
          {/*</Link>*/}
          <button 
            type="button"
            className={styles.login__supportLink} 
            onClick={() => setShowSupportPopup(true)}
          >
            {t("LOGIN_PAGE_SUPPORT_LINK")}
          </button>
        </div>
      </article>

      {showSupportPopup && (
        <div className={styles.supportPopupOverlay} onClick={() => setShowSupportPopup(false)}>
          <div className={styles.supportPopupContent} onClick={(e) => e.stopPropagation()}>
            <button 
              className={styles.supportPopupClose}
              onClick={() => setShowSupportPopup(false)}
              type="button"
            >
              ×
            </button>
            <article className={styles.supportPopupFooter}>
              <h4 className={styles.supportPopupTitle}>{t('NOT_FOUND_PAGE_FOOTER_TITLE')}</h4>
              <p className={styles.supportPopupText}>{t('SUPPORT_HOURS')}</p>
              <p className={styles.supportPopupText}>{t('TECHNICAL_SUPPORT_CONTACT')}</p>
              <p className={styles.supportPopupText}>{t('SUPPORT_URGENT_PHONE')}</p>
            </article>
          </div>
        </div>
      )}
    </section>
  );
}

export default LoginPage;
